import { useEffect, useRef } from "react";
import { isShopifyConnected } from "../utility";

export const useWebPubSub = (currentStore, onKeys) => {
  const socketRef = useRef(null);
  const storeId = currentStore?.id;
  useEffect(() => {
    let isMounted = true;

    if (!storeId || !isShopifyConnected(currentStore)) {
      console.warn(
        "⚠️ WebSocket connection skipped: Missing storeId or Shopify is not connected."
      );
      return;
    }

    const connectWebSocket = async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_BASE_URL}pubsub-negotiation`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ storeId }),
          }
        );

        if (!res.ok) {
          throw new Error(`Negotiation failed: ${res.statusText}`);
        }

        const response = await res.json();
        const storeToken = response?.storeToken;
        if (!response || !storeToken || !storeToken?.url) {
          throw new Error("No URL returned from negotiation endpoint");
        }

        const socket = new WebSocket(storeToken.url);
        socketRef.current = socket;

        socket.onopen = () => console.log("✅ WebSocket connected");
        socket.onerror = (err) => console.error("❌ WebSocket error:", err);
        socket.onclose = () => console.log("🔌 WebSocket closed");

        socket.onmessage = (event) => {
          if (!isMounted) return;

          try {
            const signalData = JSON.parse(event.data);
            if (Array.isArray(signalData?.events)) {
              if (typeof onKeys === "function") {
                onKeys(signalData.events);
              }
            }
          } catch (err) {
            console.error(
              "❌ Failed to parse WebSocket message:",
              event.data,
              err
            );
          }
        };
      } catch (error) {
        console.error("❌ Failed to connect WebSocket:", error);
      }
    };

    connectWebSocket();

    return () => {
      isMounted = false;
      if (socketRef.current) {
        socketRef.current.close();
        socketRef.current = null;
      }
    };
  }, [storeId]); // Reconnect when storeId or handler changes
};
